<dx-data-grid
  [dataSource]="familleGemrcnList"
  [showBorders]="true"
  [showColumnLines]="true"
  [showRowLines]="true"
  keyExpr="id">

  <dxo-scrolling mode="standard"></dxo-scrolling>

  <dxi-column
    width="3rem"
    cellTemplate="ligneSelectionTemplate">
  </dxi-column>

  <dxi-column
    dataField="libelle"
    caption="Famille diététique"
    width="auto"
    cellTemplate="familleCellTemplate">
  </dxi-column>

  <dxi-column
    *ngFor="let col of cols.slice(1)"
    [dataField]="col.field.toString()"
    [caption]="col.header"
    alignment="center"
    cellTemplate="checkboxCellTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'familleCellTemplate'">
    <yo-famille-gemrcn [familleNutri]="cell.data" [displayLabel]="true"></yo-famille-gemrcn>
  </div>

  <div *dxTemplate="let cell of 'checkboxCellTemplate'">
    <div class="text-center">
      <dx-check-box
        [value]="getCheckedModel(cell.data.id, cell.column.dataField)"
        (onValueChanged)="changeCheckedModel(cell.data.id, cell.column.dataField, $event)">
      </dx-check-box>
    </div>
  </div>

  <div *dxTemplate="let cell of 'ligneSelectionTemplate'">
    <div class="text-center">
      <dx-check-box
        [value]="getLigneCheckedModel(cell.data.id)"
        (onValueChanged)="changeLigneCheckedModel(cell.data.id, $event)">
      </dx-check-box>
    </div>
  </div>


</dx-data-grid>

<div class="d-flex mg-t-5">
  <div class="mr-auto">
    <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
    <em>Sélectionner les familles diététiques...</em>
  </div>
  <div class="mg-r-5">
    <yo-button iconClass="fas fa-save"
               [theme]="ButtonThemeEnum.SAVE" (onClick)="saveFamillesGemrcn()"
               [disabled]="!gds.canModify(produit)" tooltip="Enregistrer"></yo-button>
  </div>
  <div>
    <yo-button
      iconClass="fas fa-times"
      [theme]="ButtonThemeEnum.CANCEL"
      tooltip="Fermer"
      (onClick)="utils.sidenav=false">
    </yo-button>
  </div>
</div>
